(function() {
    function initFontLoader() {
        if (typeof FontFaceObserver === 'undefined') {
            console.error('FontFaceObserver library is not loaded.');
            return;
        }

        const fontsToLoad = [
            { name: 'Josefin Sans', weight: 400, style: 'normal' },
            { name: 'Josefin Sans', weight: 600, style: 'normal' },
            { name: 'Josefin Sans', weight: 700, style: 'normal' },
            { name: '01 Aeternus Nano Variable Vf', weight: 400, style: 'normal' },
            { name: '01 Aeternus Nano Variable Vf', weight: 500, style: 'normal' },
            { name: '01 Aeternus Nano Variable Vf', weight: 600, style: 'normal' }
        ];

        const fontPromises = fontsToLoad.map(font => {
            const fontFace = new FontFaceObserver(font.name, { 
                weight: font.weight, 
                style: font.style 
            });
            return fontFace
                .load(null, 5000) // 5 second timeout
                .then(() => console.log(`✓ ${font.name} (${font.weight}) loaded`))
                .catch(() => console.warn(`✗ ${font.name} (${font.weight}) failed to load`));
        });

        Promise.all(fontPromises)
            .then(() => {
                console.log('✓ All fonts loaded successfully');
                document.documentElement.classList.add('fonts-loaded');
            })
            .catch(() => {
                console.error('⚠ Some fonts failed to load');
                document.documentElement.classList.add('fonts-failed');
            });
    }

    // Execute when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFontLoader);
    } else {
        // DOM already loaded
        initFontLoader();
    }
})();